import { memo } from 'react';
import { Button, Tooltip } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Full-width `Button` that, when `reason` (an i18n key) is set, is disabled and explains why in
 * a tooltip. Used for the Owner and Admin rules of the quick actions.
 *
 * @param {object} props
 * @param {string|null} props.reason
 * @param {string} props.label
 */
function ReasonButton({ reason, label, ...props }) {
  const { t } = useTranslation('people-access');
  const button = (
    <Button {...props} disabled={Boolean(reason)} className="w-full">
      {label}
    </Button>
  );
  if (!reason) return button;
  return (
    <Tooltip content={t(reason)} triggerClassName="flex w-full">
      {button}
    </Tooltip>
  );
}

export default memo(ReasonButton);
